module.exports = __webpack_public_path__ + "img/Government_Bond_056737.03a8d057.png";